import { Label } from "@atoms"

import styles from "./ListItemLabel.module.scss"
import { ListItemLabelProps } from "./ListItemLabel.types"

export default function ListItemLabel(props: ListItemLabelProps) {
    const { label, variant, prefixSlot, suffixSlot, truncate = false, state, ...rest } = props

    return (
        <div className={styles.base}>
            {prefixSlot}
            <Label
                label={label}
                variant={variant}
                truncate={truncate}
                tooltipOnTruncate={true}
                state={state}
                {...rest}
            />
            {suffixSlot}
        </div>
    )
}
